import React from 'react';

import { DropdownItemGroup } from '@atlaskit/dropdown-menu';

import { useContentStatus } from '@confluence/page-utils/entry-points/useContentStatus';
import { usePageContentId } from '@confluence/page-context';
import { OperationTypes } from '@confluence/entity-operations/entry-points/operationsTypes';
import { useCanPerformContentOperation } from '@confluence/entity-operations/entry-points/entityOperationsHelpers';

import { CommentBulkReadWithFlags } from './CommentBulkRead';
import { CommentBulkResolveWithFlags } from './CommentBulkResolve';

export const CommentBulkActions = () => {
	const [contentId = ''] = usePageContentId();
	const { contentStatus = '' } = useContentStatus();

	const [canPerformResolveAllComments] = useCanPerformContentOperation({
		contentId,
		contentType: 'comment',
		status: [contentStatus],
		operation: OperationTypes.CREATE,
	});

	return (
		<DropdownItemGroup hasSeparator>
			<CommentBulkReadWithFlags />
			{canPerformResolveAllComments && <CommentBulkResolveWithFlags />}
		</DropdownItemGroup>
	);
};
